import { Card, Layout } from '@shopify/polaris'
import React from 'react'
import TabsComponent from './TabsComponent'

export const InputForms = () => {
    return (
        <div>
            <div class="container">
                <Layout sectioned>
                    <Layout.Section>
                        <div class='row'>
                            <div class='col-md-12  mx-auto'>
                                <Card >
                                   <TabsComponent/>
                                </Card>
                            </div>
                        </div>
                    </Layout.Section>
                </Layout>
            </div>
        </div>
    )
}
